import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import type { CodeQuestionData } from "@/types/storyboard";

interface Props {
  data: CodeQuestionData;
}

/**
 * A scenario to read and a question to weigh up. Nothing is submitted, so this
 * stays in the flow of the page instead of behind a start button.
 *
 * This subtype carries no title, so the block is headed by its icon alone.
 */
export const CodeQuestion = ({ data }: Props) => (
  <ContentBlock>
    {data.example && (
      <div className="prose max-w-full text-primary">
        <CourseMarkdown>{data.example}</CourseMarkdown>
      </div>
    )}

    {/* The question carries the block: set apart from the scenario above it,
        so the learner sees what to think about without hunting for it. */}
    <div className="mt-4 border-l-4 border-secondary-deep pl-4">
      <div className="prose max-w-full font-semibold text-primary">
        <CourseMarkdown>{data.question}</CourseMarkdown>
      </div>
    </div>
  </ContentBlock>
);
